import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, X } from 'lucide-react';
import IntegratedBookingSection from '../../components/booking/IntegratedBookingSection';
import BookingWizard from '../../components/booking/BookingWizard';
import { useLanguage } from '../../context/LanguageContext';

export default function BookingPage() {
  const { t, currentLang } = useLanguage();
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState('integrated'); // 'integrated' or 'wizard'

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="bg-[#05080e] min-h-screen py-8 sm:py-12 text-slate-200 relative">
      {/* Floating Exit 'X' Button on top-right of screen */}
      <button
        type="button"
        onClick={() => navigate('/')}
        className="fixed top-4 right-4 sm:top-6 sm:right-6 z-50 w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#070c16]/95 hover:bg-[#121c2e] border-2 border-[#c59b27] flex items-center justify-center text-slate-200 hover:text-white shadow-2xl backdrop-blur-md transition-all cursor-pointer hover:scale-105 active:scale-95"
        title="Yopish va Bosh sahifaga qaytish (X)"
        aria-label="Yopish"
      >
        <X className="w-5 h-5 text-[#c59b27]" />
      </button>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Single Clean Top Return Bar */}
        <div className="flex items-center justify-between mb-6">
          <button
            type="button"
            onClick={handleGoBack}
            className="inline-flex items-center space-x-2 text-xs font-bold uppercase tracking-wider text-[#c59b27] hover:text-white px-3.5 py-2 rounded-lg bg-[#0e1726] hover:bg-[#15233b] border border-[#c59b27]/50 hover:border-[#c59b27] transition-all cursor-pointer shadow-md group"
          >
            <ArrowLeft className="w-4 h-4 text-[#c59b27] group-hover:-translate-x-1 transition-transform" />
            <span>{currentLang === 'uz' ? 'Orqaga qaytish' : currentLang === 'ru' ? 'Назад' : 'Back'}</span>
          </button>

          <div className="flex items-center space-x-3">
            <Link
              to="/"
              className="inline-flex items-center text-xs text-slate-400 hover:text-white transition-colors"
            >
              <Home className="w-3.5 h-3.5 mr-1 text-[#c59b27]" />
              {t('nav_home', 'Bosh sahifa')}
            </Link>
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center space-x-1 px-3 py-1.5 rounded-lg bg-[#0e1726] hover:bg-[#15233b] border border-slate-700 hover:border-[#c59b27] text-xs font-semibold text-slate-300 hover:text-white transition-colors cursor-pointer"
            >
              <X className="w-4 h-4 text-[#c59b27]" />
              <span>{currentLang === 'uz' ? 'Yopish' : currentLang === 'ru' ? 'Закрыть' : 'Close'}</span>
            </button>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#c59b27] block mb-2">
            ONLINE APPOINTMENT SCHEDULER
          </span>
          <h1 className="font-serif text-3xl sm:text-5xl font-bold text-slate-100 mb-3">
            {t('nav_book_cta', 'Advokat Qabuliga Yozilish')}
          </h1>
          <p className="text-slate-400 text-xs sm:text-sm font-light">
            O‘zingizga qulay sana, vaqt va yuridik amaliyot yo‘nalishini tanlab, to‘g‘ridan-to‘g‘ri qabulga yoziling.
          </p>

          <div className="flex justify-center space-x-2 mt-6">
            <button
              onClick={() => setViewMode('integrated')}
              className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all ${
                viewMode === 'integrated'
                  ? 'bg-[#c59b27] text-black font-bold shadow-md shadow-[#c59b27]/30'
                  : 'bg-[#10192a] text-slate-400 hover:text-white'
              }`}
            >
              Tezkor 3-Panelli Jadval
            </button>
            <button
              onClick={() => setViewMode('wizard')}
              className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all ${
                viewMode === 'wizard'
                  ? 'bg-[#c59b27] text-black font-bold shadow-md shadow-[#c59b27]/30'
                  : 'bg-[#10192a] text-slate-400 hover:text-white'
              }`}
            >
              Bosqichma-bosqich Konstruktor
            </button>
          </div>
        </div>

        {viewMode === 'integrated' ? (
          <IntegratedBookingSection />
        ) : (
          <div className="bg-[#080d17] border border-[#1b2b46] rounded-2xl p-6 sm:p-10 shadow-2xl">
            <BookingWizard />
          </div>
        )}

      </div>
    </div>
  );
}
